export default __webpack_public_path__ + "static/creatives-banner-d0bd7ac44b08ea3af05c6637cf0213a6.png";